import React, { useEffect, Suspense, lazy } from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { BurningFacebookBg } from '../components/ui/BurningFacebookBg';
import { StickyFooter } from '../components/ui/StickyFooter';
import { PromoBanner } from '../components/ui/PromoBanner';
import { initMetaPixel, trackPixelEvent } from '../hooks/useMetaPixel';
const ProblemSection = lazy(() => import('../components/sections/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const BeforeAfterSection = lazy(() => import('../components/sections/BeforeAfterSection').then(m => ({
  default: m.BeforeAfterSection
})));
const WhatsIncludedSection = lazy(() => import('../components/sections/WhatsIncludedSection').then(m => ({
  default: m.WhatsIncludedSection
})));
const SolutionSection = lazy(() => import('../components/sections/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const ProductPreviewSection = lazy(() => import('../components/sections/ProductPreviewSection').then(m => ({
  default: m.ProductPreviewSection
})));
const BenefitsSection = lazy(() => import('../components/sections/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const AudienceSection = lazy(() => import('../components/sections/AudienceSection').then(m => ({
  default: m.AudienceSection
})));
const SocialProofSection = lazy(() => import('../components/sections/SocialProofSection').then(m => ({
  default: m.SocialProofSection
})));
const OfferStackSection = lazy(() => import('../components/sections/OfferStackSection').then(m => ({
  default: m.OfferStackSection
})));
const PricingSection = lazy(() => import('../components/sections/PricingSection').then(m => ({
  default: m.PricingSection
})));
function SectionDivider() {
  return <div className="max-w-3xl mx-auto px-4 md:px-5" data-id="element-617">
      <div className="h-px bg-gradient-to-r from-transparent via-border to-transparent" data-id="element-618" />
    </div>;
}
export function HookArsenalLanding() {
  useEffect(() => {
    document.title = 'Hook Arsenal Viral';
    initMetaPixel('935670149636673');
    initMetaPixel('1964119154988196');
    trackPixelEvent('PageView');
  }, []);
  return <div className="relative min-h-screen w-full bg-bg" data-id="element-619">
      <BurningFacebookBg data-id="element-620" />

      <div className="relative" style={{
      zIndex: 1
    }} data-id="element-621">
        {/* 0. Promo banner — first impression */}
        <PromoBanner data-id="element-622" />

        {/* 1. Hero — above the fold */}
        <HeroSection data-id="element-623" />

        <Suspense fallback={null} data-id="element-624">
          {/* 2. Problem agitation */}
          <SectionDivider data-id="element-625" />
          <div className="content-auto" data-id="element-626">
            <ProblemSection data-id="element-627" />
          </div>

          {/* 2.5. Before vs After comparison */}
          <SectionDivider data-id="element-628" />
          <div className="content-auto" data-id="element-629">
            <BeforeAfterSection data-id="element-630" />
          </div>

          {/* 3. What's included — value checklist */}
          <SectionDivider data-id="element-631" />
          <div className="content-auto" data-id="element-632">
            <WhatsIncludedSection data-id="element-633" />
          </div>

          {/* 4. Solution — Formula 1-3-1 */}
          <SectionDivider data-id="element-634" />
          <div className="content-auto" data-id="element-635">
            <SolutionSection data-id="element-636" />
          </div>

          {/* 4. Product preview — ebook interior pages */}
          <SectionDivider data-id="element-637" />
          <div className="content-auto" data-id="element-638">
            <ProductPreviewSection data-id="element-639" />
          </div>

          {/* 5. Benefits — transformation grid */}
          <SectionDivider data-id="element-640" />
          <div className="content-auto" data-id="element-641">
            <BenefitsSection data-id="element-642" />
          </div>

          {/* 6. Audience — for you / not for you */}
          <SectionDivider data-id="element-643" />
          <div className="content-auto" data-id="element-644">
            <AudienceSection data-id="element-645" />
          </div>

          {/* 7. Social proof — testimonials + stats */}
          <SectionDivider data-id="element-646" />
          <div className="content-auto" data-id="element-647">
            <SocialProofSection data-id="element-648" />
          </div>

          {/* 8. Offer stack — value breakdown */}
          <SectionDivider data-id="element-649" />
          <div className="content-auto" data-id="element-650">
            <OfferStackSection data-id="element-651" />
          </div>

          {/* 9. Final CTA + pricing */}
          <SectionDivider data-id="element-652" />
          <div className="content-auto" data-id="element-653">
            <PricingSection data-id="element-654" />
          </div>
        </Suspense>

        <div className="h-32 md:h-24" data-id="element-655" />
      </div>

      <StickyFooter data-id="element-656" />
    </div>;
}